var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[(_vm.isStudent)?_c('student-home-page'):_vm._e(),(_vm.isTeacher)?_c('teacher-home-page'):_vm._e(),(_vm.isManager)?_c('manager-home-page'):_vm._e(),(_vm.isAdmin)?_c('admin-home-page'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }